import React, { lazy } from 'react';
import { ArrowRightIcon, CheckIcon } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
export function CTASection() {
  const handleCTAClick = () => {
    // Track InitiateCheckout event (último paso antes de Stripe)
    if (typeof window !== 'undefined' && (window as any).fbq) {
      ;
      (window as any).fbq('track', 'InitiateCheckout', {
        content_name: 'Guía TikTok Shop',
        content_category: 'Digital Product',
        value: 190,
        currency: 'MXN',
        num_items: 1
      });
    }
  };
  return <section className="section-spacing bg-gradient-premium" data-id="element-300">
      <div className="container-narrow" data-id="element-301">
        {/* Countdown */}
        <div className="mb-8" data-id="element-302">
          <CountdownTimer data-id="element-303" />
        </div>

        <div className="bg-white rounded-2xl shadow-premium overflow-hidden" data-id="element-304">
          <div className="grid lg:grid-cols-5 gap-0" data-id="element-305">
            {/* Left: Image - OPTIMIZADA */}
            <div className="lg:col-span-2 relative h-64 lg:h-auto overflow-hidden" data-id="element-306">
              <img src="https://cdn.magicpatterns.com/uploads/chGRP5NYZH46arEH1HvpgZ/banner-13955.jpg" alt="Guía TikTok Shop para Mujeres Mexicanas" width="800" height="600" loading="lazy" decoding="async" className="w-full h-full object-contain lg:object-cover" data-id="element-307" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent lg:bg-gradient-to-r" data-id="element-308"></div>

              {/* Badge */}
              <div className="absolute top-3 left-3 bg-white/95 backdrop-blur-sm rounded-full px-3 py-1.5 shadow-lg" data-id="element-309">
                <span className="text-xs font-bold text-deep-cocoa" data-id="element-310">
                  ⚡ Acceso inmediato
                </span>
              </div>
            </div>

            {/* Right: Content */}
            <div className="lg:col-span-3 p-6 lg:p-8 space-y-5" data-id="element-311">
              <h2 className="text-2xl sm:text-3xl font-black text-deep-cocoa" data-id="element-312">
                Empieza a ganar hoy mismo
              </h2>

              <p className="text-base text-deep-cocoa/80" data-id="element-313">
                Únete a las 2,347 mujeres que ya generan $500-$2,000 MXN extra
                cada semana
              </p>

              {/* What's included */}
              <div className="bg-almond-milk rounded-xl p-4 space-y-2.5" data-id="element-314">
                {['Guía completa paso a paso (PDF + Videos)', '50 Scripts de video probados', 'Plantillas de Canva editables', 'Grupo privado de WhatsApp', 'Actualizaciones de por vida'].map((item, i) => <div key={i} className="flex items-center gap-2.5" data-id="element-315">
                    <CheckIcon className="w-4 h-4 text-accent-success flex-shrink-0" data-id="element-316" />
                    <span className="text-deep-cocoa/90 text-sm" data-id="element-317">{item}</span>
                  </div>)}
              </div>

              {/* Price - 70% descuento */}
              <div className="space-y-1.5" data-id="element-318">
                <div className="flex items-baseline gap-2.5" data-id="element-319">
                  <span className="text-base text-deep-cocoa/60" data-id="element-320">Valor:</span>
                  <span className="text-xl font-bold text-deep-cocoa/40 line-through" data-id="element-321">
                    $633
                  </span>
                </div>
                <div className="flex items-baseline gap-2.5" data-id="element-322">
                  <span className="text-base text-deep-cocoa/60" data-id="element-323">
                    Hoy pagas:
                  </span>
                  <span className="text-5xl font-black text-gradient-orange" data-id="element-324">
                    $190
                  </span>
                  <span className="text-lg text-deep-cocoa/70" data-id="element-325">MXN</span>
                </div>
                <p className="text-xs text-deep-cocoa/60" data-id="element-326">
                  Pago único • Sin mensualidades • Acceso de por vida
                </p>
                <p className="text-sm font-bold text-cta-primary" data-id="element-327">
                  Ahorras $443 MXN (70% descuento)
                </p>
              </div>

              {/* CTA */}
              <a href="https://buy.stripe.com/dRm28rgfodEa83g1X618c00" onClick={handleCTAClick} className="group inline-flex items-center justify-center gap-2.5 px-7 py-4 bg-gradient-to-r from-cta-primary to-cta-secondary text-white text-base font-bold rounded-xl shadow-glow-orange hover:shadow-xl hover:scale-105 transition-all duration-300 w-full" data-id="element-328">
                Sí, Quiero Mi Guía Ahora
                <ArrowRightIcon className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-329" />
              </a>

              {/* Trust badges */}
              <div className="flex flex-wrap items-center justify-center gap-3 text-xs text-deep-cocoa/70 pt-3 border-t border-deep-cocoa/10" data-id="element-330">
                <span className="flex items-center gap-1" data-id="element-331">
                  <CheckIcon className="w-3.5 h-3.5 text-accent-success" data-id="element-332" />
                  4.9/5 estrellas
                </span>
                <span className="flex items-center gap-1" data-id="element-333">
                  <CheckIcon className="w-3.5 h-3.5 text-accent-success" data-id="element-334" />
                  Garantía 30 días
                </span>
                <span className="flex items-center gap-1" data-id="element-335">
                  <CheckIcon className="w-3.5 h-3.5 text-accent-success" data-id="element-336" />
                  Pago seguro
                </span>
              </div>
            </div>
          </div>
        </div>

        <p className="text-center text-xs text-deep-cocoa/60 mt-6" data-id="element-337">
          ⚠️ Este precio termina cuando el contador llegue a cero
        </p>
      </div>
    </section>;
}